import React, { useCallback, useEffect } from 'react'
import styles from './UnlicencedUser.module.css'
import { t } from 'i18next'
import PinkBottom from '../../assets/images/pink_bottom.jpg'
import LaptopAndPhonePic from '../../assets/images/laptop_and_phone.png'
import { Button } from '../../common/components/button/Button'
import { HelpMenu } from '../../composites/HelpMenu/HelpMenu'
import { useUser } from '../../contexts/userContext'
import { useParams } from 'react-router-dom'
import { getClientInfo } from '../../util/browserSpecifics'

export const UnlicencedUser: React.FC = () => {
  const { user } = useUser()
  const { gameId: gameIdParam } = useParams()

  const handleContactUs = useCallback(() => {
    if (!window.Beacon) {
      console.warn('HelpScout Beacon is not available')
      return
    }

    const clientInfo = getClientInfo()

    const identifyData: Record<string, any> = {}

    if (user?.contactName) identifyData.name = user.contactName
    if (user?.email) identifyData.email = user.email
    if (user?.activeBusiness?.id) identifyData['business-id'] = user.activeBusiness.id
    if (user?.activeBusiness?.industry) identifyData.industry = user.activeBusiness.industry
    if (gameIdParam) identifyData['game-id'] = gameIdParam
    if (user?.activeBusiness?.name) identifyData.company = user.activeBusiness.name

    // Always include client info if available
    identifyData['browser-name'] = clientInfo.browser
    identifyData['device-type'] = clientInfo.deviceType
    identifyData.platform = clientInfo.platform
    identifyData['user-agent'] = clientInfo.userAgent

    window.Beacon('identify', identifyData)

    window.Beacon('open')
  }, [
    user?.contactName,
    user?.email,
    user?.activeBusiness?.id,
    user?.activeBusiness?.industry,
    user?.activeBusiness?.name,
    gameIdParam,
  ])

  const handleBackToLogin = useCallback(() => {
    window.location.replace('/login')
  }, [])

  useEffect(() => {
    localStorage.removeItem('sessionKey')
  }, [])

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <img className={styles.pinkBottom} src={PinkBottom} alt='Bottom' />
        <img className={styles.laptopAndPhone} src={LaptopAndPhonePic} alt='Laptop and Phone' />
        <div className={styles.contentArea}>
          <div className={styles.title}>{t('unlicenced_user.title', 'Welcome back!')}</div>
          <br />
          <div className={styles.basicText}>
            {t('unlicenced_user.content', "Your seppo account isn't linked to a licence.")}
          </div>
          <div className={styles.basicText}>
            {t('unlicenced_user.content2', 'No worries! Our support team is here to help you get set up!')}
          </div>
          <br />
          <div className={styles.buttons}>
            <Button variant='normal' onClick={handleContactUs} tabIndex={0}>
              {t('unlicenced_user.contact_us', 'Contact us')}
            </Button>
            <Button variant='outline-normal' onClick={handleBackToLogin} tabIndex={0}>
              {t('unlicenced_user.back_to_login', 'Back to login')}
            </Button>
          </div>
        </div>
        <br />
      </div>
      <HelpMenu buttonClassName={styles.invertedHelpButton} shouldMirror={false} />
    </div>
  )
}
